import { c as _c } from "react/compiler-runtime";
import type { ContactDetailsInput } from '@data-access/graphql/schema.types';
import { SendContactFormDocument } from '@data-access/lib/gql/service/documents';
import { useGraphQLMutation } from '@data-access/lib/graphql-query';
import { formatDate } from '@utils/utils-format';
import * as v from 'valibot';
interface GroupsContactFormState {
  region: string;
  date: Date;
  countAdults: number | null;
  countChildren?: number;
  message?: string;
  contactDetails: ContactDetailsInput;
}
const initialValues = {
  region: '',
  date: '',
  countAdults: '',
  countChildren: '',
  message: '',
  contactDetails: {
    emailAddress: '',
    firstName: '',
    lastName: '',
    phone: ''
  }
};
const mapSubmission = (data: GroupsContactFormState) => {
  const {
    countAdults,
    countChildren,
    date,
    message,
    contactDetails,
    region
  } = data;
  const parsedChildrenCount = Number(countChildren);
  return {
    region,
    date: formatDate(date),
    adultCount: Number(countAdults),
    childrenCount: parsedChildrenCount ? parsedChildrenCount : null,
    text: message,
    contactDetails
  };
};
export const useGroupsContactForm = () => {
  const $ = _c(4);
  const {
    mutate: sendForm,
    isPending: isSubmitting
  } = useGraphQLMutation(SendContactFormDocument);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const contactSchema = v.object({
      emailAddress: v.pipe(v.string("Pflichtfeld"), v.minLength(1, "Pflichtfeld"), v.email("Bitte gib eine g\xFCltige E-Mail-Adresse ein")),
      firstName: v.string(),
      lastName: v.string(),
      phone: v.string()
    });
    const requiredDateFromString = v.pipe(v.union([v.string(), v.date()], "Pflichtfeld"), v.transform(_temp), v.check(_temp2, "Pflichtfeld"));
    const requiredCountFromString = v.pipe(v.string("Pflichtfeld"), v.minLength(1, "Pflichtfeld"), v.transform(Number));
    const optionalCountFromString = v.pipe(v.string(), v.transform(Number));
    t0 = v.object({
      region: v.pipe(v.string(), v.minLength(1, "Pflichtfeld")),
      date: requiredDateFromString,
      countAdults: requiredCountFromString,
      countChildren: optionalCountFromString,
      message: v.string(),
      contactDetails: contactSchema
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const validationSchema = t0;
  let t1;
  if ($[1] !== isSubmitting || $[2] !== sendForm) {
    t1 = {
      validationSchema,
      initialValues,
      mapSubmission,
      sendForm,
      isSubmitting
    };
    $[1] = isSubmitting;
    $[2] = sendForm;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(value) {
  return value instanceof Date ? value : new Date(value);
}
function _temp2(value_0) {
  return !Number.isNaN(value_0.getTime());
}